exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".error-wrapper{margin:0 20px}.error-wrapper h3{color:#fafafa}.error-details,.error-details-button-wrapper,.error-wrapper{display:none}.error-details{white-space:pre-wrap}.error-details-button-wrapper{margin:10px}.error-visible{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/sass-loader/dist/cjs.js!./components/lib/Errorable/errorable.scss
// module id = 688
// module chunks = 0 1 2